// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import VueScroll from 'vuescroll';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ListWithAddonsMixin } from '../ui/ListWithAddonsMixin';
import { ReadMoreLink } from '../ReadMoreLink';
import { ThumbnailsListItem } from '../ThumbnailsListItem/ThumbnailsListItem';
/**
 * ThumbnailsList component with support for addons mixed within the list
 *
 * Maintains proper order of elements as received from API:
 * - Articles are rendered in their original order from the API
 * - Addons with specific positions are inserted at those positions
 * - Addons without positions are added at the end
 *
 * Example:
 * Articles: [A1, A2, A3, A4, A5]
 * Addons: [{module: X, position: 1}, {module: Y, position: 3}, {module: Z}]
 * Result: [A1, X, A2, A3, Y, A4, A5, Z]
 *
 * @author AI Assistant
 */
let ThumbnailsListWithAddons = class ThumbnailsListWithAddons extends ListWithAddonsMixin {
    constructor() {
        /**
         * Articles to be rendered (overrides base type for thumbnail support).
         */
        // @Prop({ type: Array, required: true })
        // declare public readonly articles: ContentSneakPeakDataWithThumbnail[]
        super(...arguments);
        /**
         * Local copy of articles with prepared thumbnails
         */
        this.preparedArticles = [];
    }
    onArticlesChange() {
        // this.prepareArticles()
    }
    /**
     * Prepares articles with thumbnails
     */
    prepareArticles() {
        // this.preparedArticles = this.items.map((item: MergedListItem) => {
        //   const preparedArticle = { ...article }
        //
        //   if (
        //     typeof article.properties.cover === 'object' && article.properties.cover !== null &&
        //     typeof article.properties.cover.image === 'object' && article.properties.cover.image !== null
        //   ) {
        //     preparedArticle.thumbnail = prepareImage(article.properties.cover.image, ImageRatio.Tile, 90, this.isLazy)
        //   } else {
        //     preparedArticle.thumbnail = undefined
        //   }
        //
        //   return preparedArticle
        // })
    }
};
__decorate([
    Prop({ type: String, required: false, default: '' })
], ThumbnailsListWithAddons.prototype, "fallbackImage", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ThumbnailsListWithAddons.prototype, "isLazy", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ThumbnailsListWithAddons.prototype, "windowService", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ThumbnailsListWithAddons.prototype, "tile", void 0);
__decorate([
    Watch('items', { immediate: true })
], ThumbnailsListWithAddons.prototype, "onArticlesChange", null);
ThumbnailsListWithAddons = __decorate([
    Component({
        name: 'ThumbnailsListWithAddons',
        components: {
            ReadMoreLink,
            ThumbnailsListItem,
            VueScroll
        },
        template: `
    <div class="thumbnails-list">
    <div class="thumbnails-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <!-- Mixed articles and addons list -->
      <ul v-if="items && items.length" class="list-unstyled">
        <template v-for="item in items">
          <!-- Article item -->
          <ThumbnailsListItem
            v-if="item.type === 'article'"
            :key="item.key"
            v-bind="tile"
            :item="item"
            :list-config="listConfig" />
          <!-- Addon item -->
          <li v-else-if="item.type === 'addon'"
              :key="item.key"
              class="thumbnails-list__addon-item">
            <component :is="getAddonComponent(item.data)" v-bind="getAddonProps(item.data)" />
          </li>
        </template>
      </ul>
      <!-- END | Mixed articles and addons list -->
    </div>

    <!-- "Read more" button -->
    <div v-if="readMoreLink" class="thumbnails-list__read-more-link">
      <ReadMoreLink :link="readMoreLink" />
    </div>
    </div>
  `
    })
], ThumbnailsListWithAddons);
export { ThumbnailsListWithAddons };
